import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.InnboMobilNettbrettEllerPc,
        tekst: 'Skade på mobil, nettbrett eller PC',
    },
    {
        id: KategoriSvarId.InnboTvOgAndreElektriskeArtikler,
        tekst: 'Skade på TV og andre elektriske artikler',
    },
    {
        id: KategoriSvarId.InnboEiendelerSykkeltyveri,
        tekst: 'Sykkeltyveri',
    },
    {
        id: KategoriSvarId.InnboTyveri,
        tekst: 'Tyveri andre eiendeler',
    },
    {
        id: KategoriSvarId.InnboOdelagteMatvarerIFryserEllerKjoleskap,
        tekst: 'Ødelagte matvarer i fryser eller kjøleskap',
    },
    {
        id: KategoriSvarId.InnboSkadedyrSkadeinsekter,
        tekst: 'Bekjempelse av skadedyr/skadeinsekter',
    },
    {
        id: KategoriSvarId.InnboSkadePaAndreEiendeler,
        tekst: 'Skade på andre eiendeler',
    },
];

export const InnboOgEiendeler = () => {
    const { url } = useConfig().links.innbolandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.InnboMobilNettbrettEllerPc) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.InnboEiendelerMobilNettbrettPc));
        } else if (svarId === KategoriSvarId.InnboTvOgAndreElektriskeArtikler) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.InnboEiendelerTvElektriskeArtikler));
        } else if (svarId === KategoriSvarId.InnboEiendelerSykkeltyveri) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.InnboEiendelerSykkeltyveri));
        } else if (svarId === KategoriSvarId.InnboTyveri) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.InnboEiendelerTyveri));
        } else if (svarId === KategoriSvarId.InnboOdelagteMatvarerIFryserEllerKjoleskap) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.InnboEiendelerMatvarerFryserKjoleskap));
        } else if (svarId === KategoriSvarId.InnboSkadedyrSkadeinsekter) {
            navigate(urler().soppRateSkadedyr);
        } else if (svarId === KategoriSvarId.InnboSkadePaAndreEiendeler) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.InnboEiendelerSkadePaAndreEiendeler));
        }
    };

    return (
        <GruppeLandingsside
            title="Innbo og eiendeler"
            onNext={onNext}
            radioButtonsLabel="Hva har skjedd?"
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            svgCardType={SvgCardType.Innbo}
            kategoriId="innbo-eiendeler"
        />
    );
};
